<style lang="stylus" scoped>
    #ai-list
      margin 24px 40px
      .back-btn
            display flex
            align-items center
            cursor pointer
            width min-content

            &:hover
                  opacity 0.8
            img
                  display block
                  width 16px
                  height 16px
                  margin-right 4px
            span
                  font-size 16px
                  font-weight 700
                  line-height 20px
                  text-wrap nowrap;
                  color #000
      .title
            margin 24px 0
            font-size 16px
            font-weight 700
            color #222
      .ai-funcs
            display grid
            grid-template-columns repeat(auto-fill, minmax(204px, 1fr))
            grid-gap 16px
            .ai-func-item
                  display flex
                  min-width 204px
                  max-width 220px
                  align-items center
                  height 64px
                  line-height 64px
                  padding 16px;
                  border 1px solid rgba(0,0,0,0.08)
                  border-radius 8px
                  cursor pointer
                  &:hover
                        border-color: #017fff;
                  img
                        display block
                        width 32px
                        height 32px
                        margin-right 8px
                  span
                        font-size 14px
                        color #222
                        line-height 18px
</style>

<template>
    <div id="ai-list">
        <div class="back-btn" @click="backHome">
            <img :src="require('@/app/assets/img/print/arrow_left.svg')" alt="" />
            <span>{{ $t("back") }}</span>
        </div>
        <div class="title">{{ $t("aiTitle") }}</div>
        <div class="ai-funcs">
            <div class="ai-func-item" v-for="(item, index) in aiFuncs" :key="index" @click="handleClickAI(item)">
                <img :src="require(`@/home/assets/img/aiList/${item.name}.svg`)" alt="" class="icon" />
                <span>{{ item.label }}</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Mixins } from "vue-property-decorator";
    import addNew from "../addNew";

    @Component
    export default class AIList extends Mixins(addNew) {
        get aiFuncs() {
            return [
                { name: "aiflowchart", key: "flowchart", libKey: "empty", label: this.$t("aiflowchart") },
                { name: "aimindmap", key: "mindmap", libKey: "mindmap", label: this.$t("aimindmap") },
                { name: "aiTimeline", key: "timeline", label: this.$t("aiTimeline") },
                { name: "aiDraw", key: "aiDraw", label: this.$t("aiDraw") },
                { name: "aiQA", key: "chat", label: this.$t("aiQA") },
                { name: "aiTable", key: "table", label: this.$t("aiTable") },
                { name: "aiList", key: "list", label: this.$t("aiList") },
                { name: "aiSwot", key: "swot", label: this.$t("aiSwot") },
                { name: "aiCanvas", key: "canvas", label: this.$t("aiCanvas") },
                { name: "aiPest", key: "pest", label: this.$t("aiPest") },
                { name: "aiStory", key: "story", label: this.$t("aiStory") },
                { name: "aiPortrait", key: "portrait", label: this.$t("aiPortrait") },
                { name: "aiDocument", key: "documentAnalysis", label: this.$t("aiDocument") },
                { name: "aiChart", key: "line", label: this.$t("aiChart") },
                { name: "aiGauge", key: "gauge", label: this.$t("aiGauge") },
            ];
        }

        backHome() {
            this.$router.push("/new");
            this.sensors.track("clickAIToolsPage", {
                Catalogues: "AIrecommendation",
                click_type: "back",
            });
        }

        handleClickAI(item) {
            this.activeAIKey = item.key;
            this.aiPanelKey = item.libKey ?? "";
            this.addNewPage("aiTool");
            let click_type = item.key;
            if (item.key === "line") {
                click_type = "chart";
            }
            if (item.key === "gauge") {
                click_type = "dial";
            }
            this.sensors.track("clickAIToolsPage", {
                Catalogues: "AIrecommendation",
                click_type,
            });
        }

        created() {}
        mounted() {}
        beforeDestroy() {}
    }
</script>
<i18n>
{
    "zh": {
      "back": "返回",
      "aiTitle": "AI 功能",
      "aiflowchart": "AI 流程图",
      "aimindmap": "AI 思维导图",
      "aiTimeline": "AI 时间线",
      "aiDraw": "AI 绘画",
      "aiQA": "AI 问答",
      "aiTable": "AI 表格",
      "aiList": "AI 列表",
      "aiSwot": "AI SWOT分析",
      "aiCanvas": "AI 精益画布",
      "aiPest": "AI PEST分析",
      "aiStory": "AI 用户故事",
      "aiPortrait": "AI 用户画像",
      "aiDocument": "AI 文件分析",
      "aiChart": "AI 图表",
      "aiGauge": "AI 仪表盘",

      "newFile": "未命名文件",
      "create": "正在创建文件中，请稍后再试"
    },
    "en": {
      "back": "Return",
      "aiTitle": "AI Tools",
      "newFile": "Unnamed File",
      "create": "Creating file, please try again later.",
      "aiflowchart": "AI Flowchart",
      "aimindmap": "AI Mindmap",
      "aiQA": "AI Chat",
      "aiTimeline": "AI Timeline",
      "aiDraw": "AI Drawing",
      "aiChart": "AI Chart",

      "aiTable": "AI Table",
      "aiList": "AI List",
      "aiSwot": "AI SWOT Analysis",
      "aiCanvas": "AI Lean Canvas",
      "aiPest": "AI PEST Analysis",
      "aiStory": "AI User Story",
      "aiPortrait": "AI User Profile",
      "aiDocument": "AI Document Analysis",
      "aiChart": "AI Chart",
      "aiGauge": "AI Dial"
      
    },
    "fr": {
      "back": "retour",
      "aiTitle": "Outils d'IA",
      "newFile": "Fichier sans nom",
      "create": "Création du fichier, veuillez réessayer plus tard",
      "aiflowchart": "Organigramme IA",
      "aimindmap": "Carte mentale par IA",
      "aiQA": "Chat AI",
      "aiDraw": "Dessin AI",
      "aiChart": "Graphique IA",

      "aiflowchart": "Organigramme IA",
      "aimindmap": "Carte mentale par IA",
      "aiQA": "Chat AI",
      "aiTimeline": "Chronologie IA",
      "aiPicture": "Analyse d'image par IA",
      "aiDraw": "Dessin AI",

      "aiTable": "Tableau IA",
      "aiList": "Liste IA",
      "aiSwot": "Analyse SWOT IA",
      "aiCanvas": "Lean Canvas IA",
      "aiPest": "Analyse PEST IA",
      "aiStory": "Récit utilisateur IA",
      "aiPortrait": "Profil utilisateur IA",
      "aiDocument": "Analyse de documents IA",
      "aiChart": "Graphique IA",
      "aiGauge": "Cadran IA"
    },
    "de": {
      "back": "Rückkehr",
      "aiTitle": "AI Tools",
      "newFile": "Unbenannte Datei",
      "create": " Datei wird erstellt, versuchen Sie es später erneut",
      "aiflowchart": "AI Flussdiagramm",
      "aimindmap": "AI Mindmap",
      "aiQA": "AI Chat",
      "aiTimeline": "AI Zeitachse",
      "aiPicture": "AI Bildanalyse",
      "aiDraw": "AI Drawing",

      "aiTable": "AI Tabelle",
      "aiList": "AI Liste",
      "aiSwot": "AI SWOT-Analyse",
      "aiCanvas": "AI Lean Canvas",
      "aiPest": "AI STEP-Analyse",
      "aiStory": "AI User Story",
      "aiPortrait": "AI Benutzerprofil",
      "aiDocument": "AI Dokumentanalyse",
      "aiChart": "KI-Diagramm",
      "aiGauge": "AI Ziffernblatt"
    },
    "jp": {
      "back": "戻る",
      "aiTitle": "AIツール",
      "newFile": "名前のないファイル",
      "create": "ファイルを作成しています。しばらくしてからもう一度お試しください",
      "aiflowchart": "AIフローチャート",
      "aimindmap": "AIマインドマップ",
      "aiQA": "AIチャット",
      "aiTimeline": "AIタイムライン",
      "aiPicture": "AI画像解析",
      "aiDraw": "AI描画",

      "aiTable": "AIテーブル",
      "aiList": "AIリスト",
      "aiSwot": "AI SWOT分析",
      "aiCanvas": "AIリーンキャンバス",
      "aiPest": "AI PEST分析",
      "aiStory": "AIユーザーストーリー",
      "aiPortrait": "AIユーザープロファイル",
      "aiDocument": "AIドキュメント分析",
      "aiChart": "AI チャート",
      "aiGauge": "AIダイヤル"
    },
    "es": {
      "back": "regreso",
      "aiTitle": "Herramientas de IA",
      "newFile": "Archivo sin nombre",
      "create": "Creando archivo, por favor intente nuevamente más tarde.",
      "aiflowchart": "Diagrama de flujo con IA",
      "aimindmap": "Mapa mental con IA",
      "aiQA": "Chat de AI",
      "aiDraw": "Dibujo de AI",
      "aiChart": "Gráfico IA",

      "aiflowchart": "Diagrama de flujo con IA",
      "aimindmap": "Mapa mental con IA",
      "aiQA": "Chat de AI",
      "aiTimeline": "Línea de tiempo con IA",
      "aiPicture": "Análisis de imágenes con IA",
      "aiDraw": "Dibujo de AI",

      "aiTable": "Tabla con IA",
      "aiList": "Lista con IA",
      "aiSwot": "Análisis SWOT con IA",
      "aiCanvas": "Lienzo en blanco con IA",
      "aiPest": "Análisis PEST con IA",
      "aiStory": "Caso de usuario con IA",
      "aiPortrait": "Perfil de usuario con IA",
      "aiDocument": "Análisis de documentos con AI",
      "aiChart": "Gráfico IA",
      "aiGauge": "Dial con IA"
    },
     "it": {
      "back": "ritorno",
      "aiTitle": "Strumenti AI",
      "newFile": "File Senza Nome",
      "create": "Creazione file in corso. Si prega di riprovare.",
      
      "aiflowchart": "Diagramma di flusso AI",
      "aimindmap": "Mappa mentale AI",
      "aiQA": "Chat AI",
      "aiTimeline": "Timeline AI",
      "aiPicture": "Analisi immagine AI",
      "aiDraw": "Disegno AI",

      "aiTable": "Tabella AI",
      "aiList": "Elenco AI",
      "aiSwot": "Analisi SWOT AI",
      "aiCanvas": "Lean Canvas AI",
      "aiPest": "Analisi PEST AI",
      "aiStory": "Storia utente AI",
      "aiPortrait": "Profilo utente AI",
      "aiDocument": "Analisi documenti AI",
      "aiChart": "Grafico IA",
      "aiGauge": "Quadrante AI"
    },
    "pt": {
      "back": "Retorna",
      "aiTitle": "Ferramentas de IA",
      "newFile": "Ficheiro Sem Nome",
      "create": "Criando ficheiro, por favor, tentar mais tarde.",
      "aiflowchart": "Fluxograma de IA",
      "aimindmap": "Mapa de ideias de IA",
      "aiQA": "Chat por IA",
      "aiTimeline": "Linha do tempo de IA",
      "aiPicture": "Análise de imagem por IA",
      "aiDraw": "Desenho por IA",

      "aiTable": "Tabela de IA",
      "aiList": "Lista de IA",
      "aiSwot": "Análise de SWOT de IA",
      "aiCanvas": "Lean Canvas de IA",
      "aiPest": "Análise PEST de IA",
      "aiStory": "História de usuário de IA",
      "aiPortrait": "Perfil de usuário de IA",
      "aiDocument": "Análise de documento de IA",
      "aiChart": "Gráfico de IA",
      "aiGauge": "Mostrador de IA"
    }
}
</i18n>
